import { OlliCartSummaryUrl, OlliCartUrl } from "../directives/utilities/urls";
export default function olliCartFeeSummary() {
    return {
        showErrorMesage: "",
        showLoader: false,
        basketTotal: 0,
        isSuccess:false,
        total_Amount: '',
        olliCartUrl:OlliCartUrl,
        formatDate(dateValue) {
            const options = { month: "short", day: "numeric" };
            const formattedDate = new Date(dateValue).toLocaleDateString(
                undefined,
                options
            );
            return formattedDate;
        },
  
        removeCartList(item) {
            if (confirm("Are you sure to remove this course from your cart?")) {
                var jsonData = JSON.stringify({
                    "UserSessionId": "",
                    "AcademicYear": item.academicYear,
                    "AcademicTerm": item.academicTerm,
                    "AcademicSession": item.academicSession,
                    "SerialId": item.serialId
                });
                this.showLoader = true;

                fetch("/api/Checkout/delete-course-from-cart", {
                    method: "POST",
                    headers: {
                        Accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: jsonData,
                })
                    .then((response) => {
                        return response.json();
                    })
                    .then((response) => {
                        this.showLoader = false;
                        if (response != undefined && response.isSuccess) {
                            this.bindCartList();
                        } else {
                            this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                        }
                    });
            }

        },
        btnCancelClick() {
            document.location.href = '/api/login/SignOut';
        },
        bindBasketList() {
            this.showLoader = true;
            this.enrollmentCartList = []; 

            fetch("/api/OlliCheckout/LoadPayment", {
                method: "GET",
                headers: {
                    Accept: "application/json",
                    "Content-Type": "application/json",
                },

            })
                .then((response) => {
                    return response.json();
                })
                .then((response) => {
                    this.showLoader = false;
                    if (response != undefined && response.isSuccess) {
                        if (response.redirectToCheckout) {
                            window.location.href = OlliCartSummaryUrl;
                        } else if (response.allowPayment) {
                            this.total_Amount = response.transcripts.reduce((sum, item) => sum += item.fee, 0);
                            Array.prototype.push.apply(this.enrollmentCartList, response.transcripts);
                        }
                    }
                    else {
                        this.showErrorMesage = "An unknown error has occurred. Please try again later.";
                    }
                });
            
        },
        init() {
            this.bindBasketList();
        },
    };
}
